import axios from "axios";

export type SupportProduct = 'all' | 'basic' | 'advanced';

export interface SupportSource {
    title: string;
    url: string;
}

export interface SupportAssistantResponse {
    answer: string;
    sources: SupportSource[];
    passages?: { title: string; text: string; source?: SupportSource }[];
    handoff: boolean;
    mode: 'knowledge' | 'ollama';
}

export interface SupportAssistantStatus {
    enabled: boolean;
}

export const getSupportAssistantStatus = () =>
    axios.get<SupportAssistantStatus>('tickets/assistant');

export const askSupportAssistant = (message: string, product: SupportProduct) =>
    axios.post<SupportAssistantResponse>('tickets/assistant', { message, product });
